import { render, staticRenderFns } from "./ProfileSelect.vue?vue&type=template&id=24cbfa33&scoped=true"
import script from "./ProfileSelect.vue?vue&type=script&lang=js"
export * from "./ProfileSelect.vue?vue&type=script&lang=js"
import style0 from "./ProfileSelect.vue?vue&type=style&index=0&id=24cbfa33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cbfa33",
  null
  
)

export default component.exports